import React from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { LANGUAGES, ensureBundle } from '@/i18n';
import { useAuth } from '@/contexts/AuthContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LanguageSelector = ({ compact = true }) => {
  const { i18n } = useTranslation();
  const { user, getAuthHeader } = useAuth();
  const current = LANGUAGES.find((l) => i18n.language?.startsWith(l.code)) || LANGUAGES[0];

  const change = async (code) => {
    await ensureBundle(code);
    await i18n.changeLanguage(code);
    if (user) {
      axios.patch(`${API}/users/me`, { language: code }, { headers: { Authorization: getAuthHeader() } }).catch(() => {});
    }
  };

  return (
    <Select value={current.code} onValueChange={change}>
      <SelectTrigger data-testid="language-selector" aria-label="Idioma" className={`h-9 ${compact ? 'w-[70px] px-2' : 'w-[150px]'} bg-white`}>
        <SelectValue>{compact ? current.flag : `${current.flag} ${current.label}`}</SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-80">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            {l.flag} {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
